/**
 * `time_tracking` — measured: exactly `is` and `is not`, over the tracked duration. monday
 * offers **no** empty test and **no** ordered comparison; our round-3 list had five.
 */
import { condition } from '../filter-conditions.js';
export const timeTrackingFilterConditions = [
    condition('is', 'any_of', 'number', { id: 'any_of' }),
    condition('is not', 'not_any_of', 'number', { id: 'not_any_of' }),
];
//# sourceMappingURL=filters.js.map